"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getVariablesFromHandlebarsTemplate = void 0;
const handlebars_1 = __importDefault(require("handlebars"));
/**
 * Parse AST for variables
 *
 * @param statement - Statement to parse
 * @returns Variables
 */
function parseHandlebarsAst(statement) {
    // No variables
    if (statement.type === 'ContentStatement') {
        return {};
    }
    if (statement.type === 'PartialStatement') {
        const moustacheStatement = statement;
        const pathStatement = moustacheStatement.name;
        return {
            [pathStatement.original]: 'partial',
        };
    }
    // Parse variables from {{ var }}
    if (statement.type === 'MustacheStatement') {
        const moustacheStatement = statement;
        const paramsExpressionList = moustacheStatement.params;
        const pathExpression = moustacheStatement.path;
        const vars = [
            ...paramsExpressionList.map(({ original }) => original),
            pathExpression.original,
        ].filter((x) => !!x);
        return vars.reduce((acc, x) => Object.assign(acc, { [x]: null }), {});
    }
    // Parse from {{#each}} or {{#with}}
    if (statement.type === 'BlockStatement' && statement) {
        const moustacheStatement = statement;
        const paramsExpressionList = moustacheStatement.params;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const program = moustacheStatement.program;
        const param = paramsExpressionList[0];
        const pathExpression = moustacheStatement.path;
        if (param.type === 'SubExpression') {
            return program.body
                .map(parseHandlebarsAst)
                .reduce((acc, obj) => Object.assign(acc, obj), {});
        }
        if (pathExpression.original === 'each') {
            return {
                [param.original]: [
                    program.body
                        .map(parseHandlebarsAst)
                        .reduce((acc, obj) => Object.assign(acc, obj), {}),
                ],
            };
        }
        return {
            [param.original]: program.body
                .map(parseHandlebarsAst)
                .reduce((acc, obj) => Object.assign(acc, obj), {}),
        };
    }
    throw new Error(`Unknown statement: ${statement.type}`);
}
/**
 * Get variables from handlebars template
 *
 * @param template - Template
 * @returns Variables
 */
function getVariablesFromHandlebarsTemplate(template) {
    const ast = handlebars_1.default.parseWithoutProcessing(template);
    const results = ast.body.map(parseHandlebarsAst);
    return results.reduce((acc, data) => {
        Object.entries(data).forEach(([k, v]) => {
            const existing = acc[k];
            if (!existing) {
                return Object.assign(acc, { [k]: v });
            }
            if (Array.isArray(existing) && Array.isArray(v)) {
                return Object.assign(acc, {
                    [k]: [
                        {
                            ...existing[0],
                            ...v[0],
                        },
                    ],
                });
            }
            if (typeof existing === 'object' && typeof v === 'object') {
                return Object.assign(acc, {
                    [k]: {
                        ...existing,
                        ...v,
                    },
                });
            }
            return Object.assign(acc, {
                [k]: v,
            });
        });
        return acc;
    }, {});
}
exports.getVariablesFromHandlebarsTemplate = getVariablesFromHandlebarsTemplate;
//# sourceMappingURL=getVariablesFromHandlebarsTemplate.js.map